import { getAutocompleteEquality } from '@Utils/helpers/muiHelpers';
import {
    Autocomplete,
    AutocompleteChangeReason,
    TextField,
} from '@mui/material';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import AutomationTaskApi from '@Services/iiq/Api';

const AutomationTaskSelector = (props) => {
    const {
        automationTasks,
        selectedAutomationTaskUri,
        onSelectAutomationTask,
        isLoading,
        id,
    } = props;

    useEffect(() => {
        if (_isEmpty(automationTasks)) {
            AutomationTaskApi.getAutomationTasks();
        }
    }, []);

    const handleOnChange = (value: any, reason: AutocompleteChangeReason) => {
        const field = automationTasks[value.id];
        switch (reason) {
            case 'clear':
                onSelectAutomationTask(null);
                break;
            case 'selectOption':
                onSelectAutomationTask(field);
                break;
            default:
                break;
        }
    };

    const automationTaskOptions = automationTasks.map((f, i) => {
        return { label: f.automationTaskName, id: i };
    });

    return (
        <Autocomplete
            id={id}
            options={automationTaskOptions}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={'Select Automation Task'}
                    value={selectedAutomationTaskUri}
                />
            )}
            onChange={(e, value, reason) => handleOnChange(value, reason)}
            size="small"
            style={{ width: 300 }}
            loading={isLoading}
            isOptionEqualToValue={(option: any, value: any) =>
                value.id === option.id
            }
        />
    );
};

AutomationTaskSelector.propTypes = {
    automationTasks: PropTypes.array,
    selectedAutomationTaskUri: PropTypes.string,
    onSelectAutomationTask: PropTypes.func,
    isLoading: PropTypes.bool,
    id: PropTypes.string,
};

export default AutomationTaskSelector;
